export const requiredMessage = 'Это поле обязательно к заполнению';
export const emailRegexp = new RegExp('^(?!\\.)[a-zA-Z0-9._%+-]+(?<!\\.)@[a-zA-Z0-9.-]+(?<!\\.)\\.[a-zA-Z]{2,}$');
